module.exports = __webpack_public_path__ + "img/1.61a1d4c8.webp";